/**
 * Returns the Barbados states list to populate the select item.
 */
 export function gluky_addressfield_ky_states_list() {
  let temporalStates = [];
  const states =
  {
    '00': 'Cayman Brac',
    '01': 'George Town',
    '02': 'Grand Cayman',
  }
  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Barbados cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_ky_cities_list($state_code) {
  let temporalCities = [];
  const $data =
  {
    '00': {
        'KY1-1800': 'East End, East End Post office',
        'KY1-1801': 'East End, PO Box 00001-00216',
        'KY1-0002': 'Gun Bay, Gun bay Postal Agency',
        'KY1-0001': 'Old Man Bay, Old Man Bay Postal Agency',
    },
    '01': {
        'KY1-1001': 'Geoge Town, Airport PO Box 10001-10120',
        'KY1-1002': 'Geoge Town, Airport PO Box 10121-10240',
        'KY1-1003': 'Geoge Town, Airport PO Box 10241-10360',
        'KY1-1004': 'Geoge Town, Airport PO Box 10361-10480',
        'KY1-1005': 'Geoge Town, Airport PO Box 10481-10600',
        'KY1-1006': 'Geoge Town, Airport PO Box 10601-10720',
        'KY1-1007': 'Geoge Town, Airport PO Box 10721-11056',
        'KY1-1008': 'Geoge Town, Airport PO Box 11057-11452',
        'KY1-1009': 'Geoge Town, Airport PO Box 11453-11848',
        'KY1-1010': 'Geoge Town, Airport PO Box 11849-12244',
        'KY1-1011': 'Geoge Town, Airport PO Box 12245-12442',
        'KY1-1000': 'Geoge Town, Airport Post Office',
        'KY1-1100': 'Geoge Town, General Post Office',
        'KY1-9003': 'Geoge Town, Globeop Financial Services',
        'KY1-9000': 'Geoge Town, Government Administration',
        'KY1-9006': 'Geoge Town, LST Holdings Ltd',
        'KY1-1101': 'Geoge Town, PO Box 00001-00060',
        'KY1-1102': 'Geoge Town, PO Box 00061-00075',
        'KY2-1101': 'Geoge Town, PO Box 00076-00135',
        'KY1-1104': 'Geoge Town, PO Box 00136-00315',
        'KY1-1106': 'Geoge Town, PO Box 00316-00515',
        'KY1-1107': 'Geoge Town, PO Box 00516-00715',
        'KY1-1103': 'Geoge Town, PO Box 00716-00915',
        'KY2-1102': 'Geoge Town, PO Box 00916-01115',
        'KY3-1101': 'Geoge Town, PO Box 01116-01139',
        'KY3-1102': 'Geoge Town, PO Box 01140',
        'KY4-1101': 'Geoge Town, PO Box 01141-01158',
        'KY4-1102': 'Geoge Town, PO Box 01159-01172',
        'KY1-1108': 'Geoge Town, PO Box 01173-01380',
        'KY1-1110': 'Geoge Town, PO Box 01381-01610',
        'KY1-1109': 'Geoge Town, PO Box 01611-01820',
        'KY2-1110': 'Geoge Town, PO Box 01821-01937',
        'KY3-1110': 'Geoge Town, PO Box 01938-01964',
        'KY2-1104': 'Geoge Town, PO Box 01965-02004',
        'KY1-1105': 'Geoge Town, PO Box 02005-02225',
        'KY2-1107': 'Geoge Town, PO Box 02226-02301',
        'KY2-1106': 'Geoge Town, PO Box 02302-02378',
        'KY2-1105': 'Geoge Town, PO Box 02379-02478',
        'KY3-1104': 'Geoge Town, PO Box 02479-02555',
        'KY2-1103': 'Geoge Town, PO Box 02556-02632',
        'KY5-1102': 'Geoge Town, PO Box 02633-2638',
        'KY5-1101': 'Geoge Town, PO Box 02640-02657',
        'KY3-1107': 'Geoge Town, PO Box 02658',
        'KY1-1111': 'Geoge Town, PO Box 02660-02779',
        'KY1-1112': 'Geoge Town, PO Box 02780-02899',
        'KY1-9001': 'Geoge Town, Walkers',
        'KY1-9004': 'Geoge Town, Walkers Corp Service Ltd',
        'KY2-9004': 'Geoge Town, Walkers Fund Services',
        'KY1-9002': 'Geoge Town, Walkers SPV Ltd',
        'KY1-9007': 'Ogier'
    },
    '02': {
        'KY1-1600': 'Bodden Town, Bodden Town Post Office',
        'KY1-1601': 'Bodden Town, PO Box 00001-00272',
        'KY1-1602': 'Bodden Town, PO Box 00273-00309',
        'KY2-1602': 'Bodden Town, PO Box 00374-00640',
        'KY1-1603': 'Bodden Town, PO Box 00641-01000',
        'KY1-1501': 'Sabannah, PO Box 00001-00390',
        'KY1-1502': 'Sabannah, PO Box 00391-00848',
        'KY1-1503': 'Sabannah, PO Box 00849-01352',
        'KY1-1504': 'Sabannah, PO Box 01353-01856',
        'KY1-1505': 'Sabannah, PO Box 01857-02108',
        'KY1-1506': 'Sabannah, PO Box 02109-02360',
        'KY1-1507': 'Sabannah, PO Box 02361-02504',
        'KY1-1508': 'Sabannah, PO Box 02505-02742',
        'KY1-1500': 'Sabannah, Sabannah Post Office',
    }
}
  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

